module.exports = __webpack_public_path__ + "img/no_network.650340af.png";